import React from 'react';
import {
  injectIntl,
  // intlShape
} from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// import { TopBarContext } from 'hocs/with-top-bar';
import { RouteLink, FormattedTag } from 'core/components';
import { SkipServerRender } from 'components/skip-server-render/skip-server-render';
import { ProfileModal } from 'components/modals/profile-modal/profile-modal';
// import { DomainBar } from 'components/domain-bar/domain-bar';
// import { isEmptyOrNil } from 'core/helpers';
import {
  withBonuses,
  withModalActions,
  withUser,
  withLocale,
} from 'core/hocs';
// import { enrichRegistrationBonuses, filterOutExpiredBonuses, filterOutFutureBonuses } from 'helpers/utils';

import { RegistrationBonus } from 'components/registration-bonus/registration-bonus';
import {
  // PAYMENT_METHODS,
  USER_FIELDS,
  LOCALE_KEYS,
} from 'core/constants';
import { CasinoHeader } from './casino-header/casino-header';
import { CasinoHeaderMobile } from './casino-header/casino-header-mobile';
import { StickyHeader } from './sticky-header/sticky-header';
import { menuItems } from './menu-items';

import {
  PAGE_NAMES,
  // MODAL_IDS
} from '../../constants';

import './header.scss';
// import { usePrevious } from '../../hooks/usePrevious';

// const {
//   IS_CREDITCARD_5,
// } = PAYMENT_METHODS;

const HeaderUI = ({
  pageName,
  mobileBackRoute,
  params,
  className,
  isUserLoggedIn,
  locale,
  // openModal,
  // getDepositBonuses,
  // depositBonuses,
  // intl,
  // userData: {
  //   regDate,
  // },
}) => {
  // const { isDomainBarOpen, isRegistrationBonusOpen } = useContext(TopBarContext);
  // const isPageGame = pageName === PAGE_NAMES.GAME;
  const isGiftsPage = pageName === PAGE_NAMES.GIFTS;
  // const prevProps = usePrevious({ isUserLoggedIn }) || {};

  // useEffect(() => {
  //   const { isUserLoggedIn: isUserLoggedInPrev } = prevProps;

  //   if (!isUserLoggedInPrev && isUserLoggedIn) {
  //     getDepositBonuses({
  //       depositAmount: 1000000,
  //       // TODO: Fix payment method
  //       paymentMethod: IS_CREDITCARD_5,
  //     });
  //   }

  //   const purifiedBonuses = filterOutFutureBonuses(
  //     filterOutExpiredBonuses(enrichRegistrationBonuses(depositBonuses.items, intl, regDate, 'bonusPlanId'))
  //   );

  //   if (!isUserLoggedInPrev && isUserLoggedIn && !isEmptyOrNil(purifiedBonuses)) {
  //     openModal(MODAL_IDS.PROMO_INFO);
  //   }
  // }, [isUserLoggedIn, depositBonuses]);

  return (
    <>
      {/* {!isPageGame && !isRegistrationBonusOpen && isDomainBarOpen && <DomainBar />} */}
      {!isGiftsPage && isUserLoggedIn && <RegistrationBonus isHeader />}

      <CasinoHeader className={classNames('casino-header pl-md-0_5', className)} isSticky={false}>
        {menuItems.map(({
          id, to, pages, Icon, IconTr, classNameHeader
        }) => {
          const isActive = params ? pages.includes(`${pageName}/${params}`) : pages.includes(pageName);

          const DisplayIcon = locale === LOCALE_KEYS.TR && IconTr ? IconTr : Icon;

          return (
            <RouteLink
              key={id}
              to={to}
              className={classNames('header-item mr-md-1_25 mr-lg-3_75 d-flex align-items-center px-0_25', classNameHeader)}
            >
              <DisplayIcon
                className={classNames('header-icon', { active: isActive })}
              />
              <FormattedTag
                id={id}
                className={classNames('header-item-title h4 ml-md-0_75 ml-lg-1 letter-spacing-default', { active: isActive })}
              />
            </RouteLink>
          );
        })}
      </CasinoHeader>

      <div className="casino-header-mobile d-flex d-md-none align-items-center justify-content-between px-2 bg-black">
        <CasinoHeaderMobile pageName={pageName} mobileBackRoute={mobileBackRoute} />
      </div>

      {pageName !== PAGE_NAMES.GAMES ? (
        <StickyHeader page={pageName}>
          <CasinoHeader className="casino-sticky-header h-100" isSticky>
            {menuItems.map(({
              id, to, pages, Icon, IconTr, classNameHeader
            }) => {
              const isActive = params ? pages.includes(`${pageName}/${params}`) : pages.includes(pageName);
              const DisplayIcon = locale === LOCALE_KEYS.TR && IconTr ? IconTr : Icon;

              return (
                <RouteLink
                  key={id}
                  to={to}
                  className={classNames('header-item mr-md-1_25 mr-lg-3_75 d-flex align-items-center px-0_25', classNameHeader)}
                >
                  <DisplayIcon
                    className={classNames('header-icon', { active: isActive })}
                  />
                  <FormattedTag
                    id={id}
                    className={classNames('header-item-title h4 ml-md-0_75 ml-lg-1 letter-spacing-default', { active: isActive })}
                  />
                </RouteLink>
              );
            })}
          </CasinoHeader>

          <div className="casino-header-mobile casino-sticky-header-mobile d-flex d-md-none align-items-center justify-content-between px-2">
            <CasinoHeaderMobile pageName={pageName} mobileBackRoute={mobileBackRoute} />
          </div>
        </StickyHeader>
      ) : (
        <StickyHeader className="d-md-none" page={pageName}>
          <div className="casino-header-mobile casino-sticky-header-mobile d-flex d-md-none align-items-center justify-content-between px-2">
            <CasinoHeaderMobile pageName={pageName} mobileBackRoute={mobileBackRoute} />
          </div>
        </StickyHeader>
      )}

      <SkipServerRender skip>
        <ProfileModal />
      </SkipServerRender>
    </>
  );
};

HeaderUI.propTypes = {
  pageName: PropTypes.string,
  mobileBackRoute: PropTypes.string,
  params: PropTypes.string,
  className: PropTypes.string,
  isUserLoggedIn: PropTypes.bool.isRequired,
  locale: PropTypes.string.isRequired,
  // getDepositBonuses: PropTypes.func.isRequired,
  // depositBonuses: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  // openModal: PropTypes.func.isRequired,
  // userData: PropTypes.shape().isRequired,
  // intl: intlShape.isRequired,
};

HeaderUI.defaultProps = {
  pageName: null,
  mobileBackRoute: null,
  params: null,
  className: null,
};

export const Header = withLocale(injectIntl(withModalActions(withBonuses(withUser(
  HeaderUI, [
    USER_FIELDS.USER_DATA,
  ],
)))));
